import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {FormBuilder, FormControl, FormsModule, Validators, ReactiveFormsModule } from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {CreateRemoveAndRefitRequest} from "../../../_models/CreateRemoveAndRefitRequest";
import {QuoteService} from "../../../_services/quote.service";
import {Quote} from "../../../_models/Quote";
import {BaseComponent} from "../../../shared/base-component";
import {ToastrService} from "ngx-toastr";
import {catchError, map} from "rxjs/operators";
import {of} from "rxjs";
import {LabeledInputComponent} from "../../../shared/labeled-input/labeled-input.component";
import {SweetAlert2Module} from '@sweetalert2/ngx-sweetalert2';
import {LabeledDisplayComponent} from "../../../shared/labeled-display/labeled-display.component";

@Component({
  templateUrl: "./create-remove-and-refit.component.html",
  encapsulation: ViewEncapsulation.None,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    LabeledInputComponent,
    SweetAlert2Module,
    LabeledDisplayComponent
  ]
})

export class RemoveAndRefitComponent extends BaseComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private quoteService: QuoteService,
              protected toasterService: ToastrService, private router: Router) {
    super(toasterService);
  }

  rRForm = this.formBuilder.group({
    currentPlot: new FormControl(null, [Validators.required]),
    destinationPlot: new FormControl(null, [Validators.required]),
    park: new FormControl(null, [Validators.required]),
    comments: new FormControl(null, [Validators.required]),
    planSquareFootage: new FormControl(null, [Validators.required])
  })

  public quoteId: string;
  public quote: Quote;

  ngOnInit() {
    this.quoteId = this.route.snapshot.paramMap.get('id');

    if (this.quoteId != null) {
      this.getQuoteById();
    }
  }

  get f() {
    return this.rRForm.controls;
  }

  getQuoteById() {
    this.quoteService.getQuoteAndLatestPlan(this.quoteId).subscribe(quote => {
      this.quote = quote;
      this.f.park.patchValue(quote.park);
      this.f.currentPlot.patchValue(quote.plot);
      this.f.planSquareFootage.patchValue(quote?.plans[0]?.planSquareFootage ?? 0);
    })
  }


  createRemoveAndRefit() {
    if (!this.rRForm.valid) {
      this.showAllFormValidation(this.rRForm);
      return;
    }

    const formValue = this.rRForm.value;

    let request = new CreateRemoveAndRefitRequest();
    request.customerId = this.quote.customer.id
    request.currentPlot = formValue.currentPlot
    request.destinationPlot = formValue.destinationPlot;
    request.comments = formValue.comments;
    request.originalPlanSquareFootage = formValue.planSquareFootage;

    this.quoteService.createRemoveAndRefit(request)
      .pipe(
        map(q => {
          this.toasterService.success('Quote Created');
          this.router.navigate(['/quotes/' + q.id]);
        }),
        catchError(e => {
          this.toasterService.error(e);
          return of();
        }))
      .subscribe()
  }
}
